// Keep an open tab's requests aligned with its in-memory organization context.
// Persistence still supports remember-me, but another tab cannot silently swap
// the active token underneath this tab's already-rendered organization label.
export function createTabTokenStorage(persistent) {
  let active = persistent.get();
  return {
    get: () => active,
    set(token, opts) {
      persistent.set(token, opts);
      active = token;
    },
  };
}
